
import state from './../../zviz2/zviz/state';
import {default as Group, Controller as GroupController} from './../../zviz2/zviz/components/group';
import Rectangle from './../../zviz2/zviz/components/rectangle';
import TextBox from './../../zviz2/zviz/components/svg/textbox';
import Arc from './../../zviz2/zviz/components/arc';
import {extend} from './../../zviz2/zviz/functions';
import {styleText} from './../../styles';
import config from './../../config';

//import {LifeCycle} from './../zviz2/zviz/cycle';
import flowModel from './../../model/flow';


class Controller extends GroupController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);

        this.maxSize = 30;
        
    }

    render(renderer){
        // if(this.hasChanged){
            if(this.isHovered()){
                let e = this.renderOutput.result;
                if(e.parentNode.lastChild != e){
                    e.parentNode.appendChild(e);
                }
            }
        // }
        super.render(renderer);
    }

    restoreOrder(){
        let e = this.renderOutput.result;
        for(let i = this.parent.children.length-1; i >= 0; i--){
            if(this.parent.children[i].data.amount > this.data.amount){
                e.parentNode.insertBefore(e, this.parent.children[i].renderOutput.result);
                break;
            }
        }
    }

    getScale(){

        let amount = this.getAmount();

        return Math.max(5, Math.sqrt((amount / this.parent.maxValue)) * this.maxSize);
    }

    getAmount(){

        let hover = state.get('map.itemHover');
        let amount = 0;
        if(hover && hover[0] != this.data.dim){
            let link = this.models['flow'].getLink(this.data.dim, this.data.name, hover[0], hover[1]);
            amount = link || 0;
        }else{
            
            amount = this.data.amount;
        }
        return amount;
    }

    getSourceName(){
        let source = state.get('source');
        let sourceName = ' ' + config.data.sourceTitles[source];
        return sourceName;
    }

    isHovered(){
        let hover = state.get('map.itemHover');
        if(hover){
            let dim = hover[0];
            let value = hover[1];
            
            if(dim == this.data.dim && value == this.data.name){
                return true;
            }
        }
        return false;
    }

    getOpacity(){
        let hover = state.get('map.itemHover');
        if(hover && hover[0] == this.data.dim){
            return (hover[1] == this.data.name)? 1: 0.5;
        }else if(hover){
            let link = this.models['flow'].getLink(this.data.dim, this.data.name, hover[0], hover[1]);
            return (link==null)? 0.5: 1;
        }
        return 1;
    }

    getColor(){
        let o = this.getOpacity();
        if(o != 1){
            return '#727272';
        }
        if(this.isHovered()){
            return '#FB636F';
        }
        return '#FA3C4B'; //#bb6148
    }

    getName(){
        let name = this.data.name;
        for(let key of Object.keys(this.models['flow'].regionMap)){
            if(this.models['flow'].regionMap[key] == name){
                return key;
            }
        }
        return name;
    }

    getInfo(){

        let result = [];
        if(this.isHovered() || this.data.notOnMap){
            for(var blpr of BlueprintInfo){
                result.push(extend({
                    properties: {data: this.data}
                }, blpr));
            }
            return result;
        }
        let hover = state.get('map.itemHover');
        if(hover && hover[0] != this.data.dim){
            let link = this.models['flow'].getLink(this.data.dim, this.data.name, hover[0], hover[1]);
            if(link){
                for(var blpr of BlueprintInfo){
                    result.push(extend({
                        properties: {data: extend({noUnderline: true}, this.data)}
                    }, blpr));
                }
                return result;
            }
        }

        return [];
    }

} 


let Blueprint = extend({
    type: Controller,
    models: {
        'flow': null
    },
    listeners: [
        (ctrl) => ( ctrl.addListener(ctrl.models['flow'], [ctrl, ctrl.update])),
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.update], 'map.itemHover'))
    ],
    properties: { 
        style: { 
            cursor: (ctrl) => ( (state.get('filter.country'))? 'default': 'pointer')  
        }
    },
    children: [
        () => (extend({
            properties: { 
                transform: {
                    position: {
                        x: (ctrl) => (ctrl.parent.data.coords[0]),
                        y: (ctrl) => (ctrl.parent.data.coords[1] - 30)
                    }
                },
                data: (ctrl) => (ctrl.parent.data)
              },
            children: [ (ctrl) => ( ctrl.parent.getInfo() ) ]
        }, Group) ),

        extend({
            properties: {
                style: {
                    fill: (ctrl) => ( ctrl.parent.getColor() ),
                    stroke: 'white',
                    strokeWidth: '2px',
                    fillOpacity: (ctrl) => ( ctrl.parent.getOpacity() )
                },
                attributes: {
                    'r': (ctrl) => ( ctrl.parent.getScale() + ' => transition 400 easein' ),
                    'cx': (ctrl) => (ctrl.parent.data.coords[0]),
                    'cy': (ctrl) => (ctrl.parent.data.coords[1]),
                    'title': (ctrl) => (ctrl.parent.data.name)
                }
            }

        }, Arc)
    ],
    events: {
        click: (event, ctrl) => { 
            state.set('map.itemHover', null ); 
            state.set('filter.' + ctrl.data.dim, ctrl.getName()) 
        },
        mouseover: (event, ctrl) => { state.set('map.itemHover', [ctrl.data.dim, ctrl.getName()] ); },
        mouseout: (event, ctrl) => { 
            state.set('map.itemHover', null );
            ctrl.restoreOrder(); 
        },
    }
}, Group);

let BlueprintInfo = [ 
    extend({
        properties: {
            attributes: {
                'x': 0,
                'y': 0,
                'width': 150,
                'height': 60
            },
            style: {
                fill: 'rgba(23, 102, 139, 0.7)',
                stroke: 'white',
                strokeWidth: '1px'
            },
        }
    },Rectangle),

    extend({
        properties: {
            style: extend({
                fill: 'white'
            }, styleText),
            transform: {
                position: {
                    x: (ctrl) => (ctrl.parent.parent.getScale() + 5),
                    y: (ctrl) => (ctrl.vOffset + 18)
                }
            },
            data: {
                text: (ctrl) => ( ctrl.parent.parent.getName() ),
                height: 30,
                width: (ctrl) => (150 - ctrl.parent.parent.getScale() - 10),
                verticalAlign: 'middle',
                lineHeight: 15
            }
        }
    },TextBox),

    extend({
        properties: {
            style: extend({
                fontSize: '9pt',
                fill: 'white',
                textDecoration: (ctrl) => (ctrl.data.noUnderline? 'none': 'underline'),
                cursor: 'pointer'
            }, styleText),
            transform: {
                position: {
                    x: (ctrl) => ( ctrl.parent.parent.getScale() + 5 ),
                    y: (ctrl) => ( (ctrl.parent.children[1] && ctrl.parent.children.textHeight)? 0.5 * ctrl.parent.children.textHeight + 30: 45 )
                    // y: 45 //(ctrl) => ( ctrl.parent.children[1].textHeight + 5 )
                }
            },
            data: {
                text: (ctrl) => ( ctrl.parent.parent.getAmount() + ctrl.parent.parent.getSourceName() ),
                height: 20,
                width: (ctrl) => (170 - ctrl.parent.parent.getScale() - 10),
                verticalAlign: 'top'
            }
        },
        events: {
            click: (event, ctrl) => {
                // setting the filter for this item will hapen by the parent event that will also fire
                state.set('view', 'list'); 
            }
        }
    }, TextBox)
];


export default Blueprint;
export {Controller, Blueprint};

